import {Component, Input} from '@angular/core';
import {FORM_ERROR_SCROLL_HOOK} from 'src/app/helpers/form.helper';

@Component({
    selector: 'app-form-errors-alert',
    templateUrl: './form-errors-alert.component.html'
})
export class FormErrorsAlertComponent {
    @Input() errors: string[];
    @Input() nzType: 'success' | 'info' | 'warning' | 'error' = 'error';
    FORM_ERROR_SCROLL_HOOK = FORM_ERROR_SCROLL_HOOK;

    get alertVisible() {
        return Array.isArray(this.errors) && this.errors?.length > 0;
    }
}
